import { normalizeEmpresaA3 } from "./a3Empresas";
import logoStage from "../img/logos/Matrix6.png";
import logoNml from "../img/logos/nml.png";
import logoErna from "../img/logos/ERNA LOGO.png";

/** Domicilio social compartido (Sitges) — grupo Stage / ERNA / NML */
const SITGES_DOMICILIO = {
  address: "C/ Derechos Humanos 29",
  zip: "08870",
  city: "Sitges",
  state: "Barcelona",
  country: "España",
};

/**
 * Datos de cabecera PDF por empresa A3 (clave = EmpresaA3 / dbSource del pedido).
 * Nombres según criterio de negocio: STAGE DESIGN STUDIO, ERNA TRADE, NML España.
 */
export const A3_EMPRESA_PDF = {
  STAGE_DESIGN: {
    key: "STAGE_DESIGN",
    name: "STAGE DESIGN STUDIO",
    logo: logoStage,
    logoLayout: "square",
    vat: "ESB67361469",
    ...SITGES_DOMICILIO,
    phone: "+34 935 089 690",
    email: "",
    web: "https://stagedesign.es",
    headerRgb: [25, 118, 210],
  },
  ERNA_TRADE: {
    key: "ERNA_TRADE",
    name: "ERNA TRADE",
    logo: logoErna,
    logoLayout: "square",
    vat: "ESB75764365",
    ...SITGES_DOMICILIO,
    phone: "+34 935 089 690",
    email: "",
    web: "",
    headerRgb: [170, 25, 196],
  },
  NML_SPAIN: {
    key: "NML_SPAIN",
    name: "NML España",
    logo: logoNml,
    logoLayout: "wide",
    vat: "ESB06786768",
    ...SITGES_DOMICILIO,
    phone: "+34 935 089 690",
    email: "",
    web: "https://nomanslabel.com",
    headerRgb: [46, 125, 50],
  },
};

export const getEmpresaPdfByKey = (raw, fallback = "STAGE_DESIGN") => {
  const key = normalizeEmpresaA3(raw, fallback);
  return A3_EMPRESA_PDF[key] || A3_EMPRESA_PDF.STAGE_DESIGN;
};

/** Empresa emisora del pedido a partir de la fila CRM–A3. */
export const getEmpresaPdfFromPedidoRow = (row) =>
  getEmpresaPdfByKey(row?.EmpresaA3 || row?.dbSource);

/** Líneas de dirección para PDF (sin teléfono/email). */
export const formatEmpresaPdfAddressLines = (emp) => {
  if (!emp) return [];
  const zipCity = [emp.zip, emp.city].filter(Boolean).join(" ");
  const loc = [zipCity, emp.state, emp.country].filter(Boolean).join(", ");
  return [emp.address, loc, emp.vat ? `CIF/NIF: ${emp.vat}` : null].filter(
    Boolean,
  );
};
